module.exports = __webpack_public_path__ + "img/navigate_after_white_32px@2x.546cf560.png";